import { Tag } from '@cian/components';
import * as React from 'react';

import { PropertyTypeName } from '../../../../types/commercial';
import { IPropertyTypeTag } from '../../../state/tags/definitions/property_type';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IPropertyTypeTagItemProps {
  tag: IPropertyTypeTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const PropertyTypeTagItem = ({ tag, onDeleteClick, withNewTag }: IPropertyTypeTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {PropertyTypeName.get(tag.value)}
    </TagComponent>
  );
};
